<template>
	<div class="onboarding-card tw-text-center tw-flex tw-items-center tw-justify-center">
		<div>
			<h1>{{ toolInformation.title }}</h1>
			<p class="tw-pb-4" v-html="toolInformation.description"></p>
			<v-btn
				color="primary"
				class="btn-action"
				@click="goTo('job-evaluation-new')"
			>
				{{ hasInformationJobEvaluation ? 'Continuar' : 'Comenzar' }}
			</v-btn>
		</div>
	</div>
</template>

<script>
import { pathOr } from 'ramda';
import { mapState } from 'vuex';

export default {
	name: 'page-job-evaluation-onboarding',
	beforeMount() {
		this.$store.dispatch('jobEvaluation/loadJobEvaluationConfig');
		this.$store.dispatch('jobEvaluation/getJobValuationStatus');
	},
	computed: {
		...mapState('jobEvaluation', {
			toolInformation: pathOr({}, ['mainData', 'config']),
			hasInformationJobEvaluation: pathOr({}, ['supplies', 'guidelineModel', 'hasInformationJobEvaluation']),
		}),
	},
};
</script>

<style lang='scss' scoped>
.onboarding-card {
	border-radius: 8px;
	border: solid 1px var(--app-color-gray);
	background-color: #ffffff;
	padding: 60px 20%;
	min-height: 500px;
	h1, p {
		color: var(--app-color-info);
	}
	.btn-action {
		width: 180px !important;
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/pages/page-job-evaluation-onboarding.vue